module.exports = __webpack_public_path__ + "static/media/18ECA27.d20c5ad0.jpg";